import { reviewSessionApis } from '@gleamer/apis';
import { useSystem } from '@ohif/core';
import { useQuery } from '@tanstack/react-query';

const { fetchReviewSession } = reviewSessionApis;

export function useReviewSession({ taskId }: { taskId: number }) {
  // Core singleton (single ui-next provider owns it) rather than the @ohif/ui
  // `useUserAuthentication()` api — see the note in useSaveLabelPass.
  const { servicesManager } = useSystem();
  const { userAuthenticationService } = servicesManager.services;

  return useQuery({
    queryKey: ['review-session', taskId],
    queryFn: () => fetchReviewSession(userAuthenticationService, taskId),
    retry: false,
    cacheTime: 0,
    refetchOnWindowFocus: false,
  });
}
